import {connect} from 'react-redux'
import styles from './List.css'
import InfiniteScroll from 'react-infinite-scroller'
import {onClickRow} from 'actions/inventory/supplier'
import {askConfirmAction} from 'actions/confirm-action'
import {isDirty} from 'redux-form'

class List extends React.Component {
  render () {
    const {suppliers, supplierDetail} = this.props
    return (
      (suppliers.length > 0) && <div className={styles['wrapper']}>
        <table className={styles['table-header']}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Address</th>
              <th>Phone</th>
              <th>Email</th>
            </tr>
          </thead>
        </table>
        <div className={`${styles['table-content-wrapper']} suppliers-table-content-wrapper`}>
          <InfiniteScroll
            pageStart={1}
            loadMore={this._onReachBottom}
            hasMore={this._hasMore()}
            useWindow={false}
            threshold={10}
            initialLoad={false}
          >
            <table className={`${styles['table-content']}`}>
              <tbody>
                {suppliers.map((supplier) => {
                  const className = `${(supplierDetail && supplierDetail.id === supplier.id) ? styles.selected : ''}`
                  return <tr onClick={() => { this._onClickRow(supplier) }} className={className}>
                    <td>{supplier.name}</td>
                    <td>{supplier.address}</td>
                    <td>{supplier.phone}</td>
                    <td>{supplier.email}</td>
                  </tr>
                })}
              </tbody>
            </table>
          </InfiniteScroll>
        </div>
      </div>)
  }

  _hasMore = () => {
    // since the suppliers api doesn't support pagination
    // this method is no use
    return false
  }

  _onReachBottom = () => {
    // since the suppliers api doesn't support pagination
    // this method is no use
    return false
  }

  _onClickRow = (supplier) => {
    const {dispatch, isDirtySupplier} = this.props
    if (isDirtySupplier) {
      dispatch(askConfirmAction(onClickRow(supplier)))
    } else {
      dispatch(onClickRow(supplier))
    }
  }
}

function mapStateToProps (state) {
  const {suppliers, supplierDetail} = state.inventory.supplier
  let {showLoadingSpinnerPage} = state.loadingSpinner
  return {
    suppliers,
    supplierDetail,
    showLoadingSpinnerPage,
    isDirtySupplier: isDirty('supplier')(state)
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

List.propTypes = {
}

export default connect(mapStateToProps, mapDispatchToProps)(List)



// WEBPACK FOOTER //
// ./app/pages/Inventory/Supplier/List/List.js